export const personalRoutes =  [
  {
    path: '/personal-center/personal-center',
    name: 'personal-center-mine',
    component: () => import('@/views/modules/personal-center/personal-center/personal-center'),
    meta: { name: '个人中心', keepAlive: true }
  },
];
